import axios from "@configs/axios";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@configs/reactQuery";
import {toast} from "react-toastify";

export const updateUserGroup = ({ data }) => {
  return axios.post(`/api/user-group/`, data);
};

export const useUpdateUserGroup = ({ config } = {}) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("usersList");
      toast.success("Role added successfully");
    },
    ...config,
    mutationFn: updateUserGroup,
  });
};
